import React from "react";
import { KeraltyLoader } from "./components";
import { ServiceDataProvider } from "./context/ServiceContext";
import { FormContainer } from "./features";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 90, // 90 minutos (en milisegundos)
      gcTime: 1000 * 60 * 60 * 24, // 1 día (en milisegundos) en cache
      refetchOnWindowFocus: false, // Prevent fetching data on windows focus
      retry: 2, // Retry after 2 times services
    },
  },
});

export const RegisterForm = () => {
  return (
    <React.Suspense fallback={<KeraltyLoader />}>
      <QueryClientProvider client={queryClient}>
        <ServiceDataProvider>
          <FormContainer />
        </ServiceDataProvider>
      </QueryClientProvider>
    </React.Suspense>
  );
};
